import { LocalDateTime } from "@js-joda/core";
import { Page } from "../activities/AppPage";
import { API } from "../API";
import { CreatedModalInstance, ModalActions, useModalV2 } from "../components/AppModals";
import { getFormattedArrivalTime } from "../components/InstaPay/utils/get-instapay-arrival-time";
import { CaregiverBankInformation, InstaPayVisit } from "../messages";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { HashSet } from "../utils/HashSet";
import useWithdrawPayment from "./useWithdrawPayment";

export default function useInstaPay(params: {
  api: API;
  onRequestNavigate: (page: Page) => void;
  onRequestGoToMain: () => void;
}) {
  const withdrawPayment = useWithdrawPayment({ api: params.api });
  const modals = useModalV2();

  const withdraw = ($params: {
    modalInstance?: CreatedModalInstance;
    visits: HashSet<Pick<InstaPayVisit, "id">>;
    bankInformation: Pick<CaregiverBankInformation, "hasAgreedToTerms"> | null;
  }) => {
    if ($params.bankInformation?.hasAgreedToTerms !== true) {
      params.onRequestNavigate({
        type: "FillBankInformation",
        visitInstanceIds: $params.visits.toArray().map((x) => x.id),
      });
      return;
    }

    const modal =
      $params.modalInstance ??
      modals.createModal({ type: "info", isLoading: true, title: "", actions: [] });

    withdrawPayment.mutate(
      $params.visits.toArray().map((x) => x.id),
      {
        onSuccess: () => {
          modal.update({
            type: "success",
            isLoading: false,
            title: translate(STRINGS.YOU_JUST_GOT_PAID),
            message: translate(STRINGS.PAYROLL_STATUS_IN_PROGRESS_MESSAGE).replace(
              "{PROCESS_TIME}",
              getFormattedArrivalTime(LocalDateTime.now())
            ),
            actions: [
              ModalActions.Close({
                onClick: params.onRequestGoToMain,
                children: translate(STRINGS.GO_BACK),
              }),
            ],
          });
        },
        onError: () =>
          modal.update({
            type: "error",
            isLoading: false,
            title: translate(STRINGS.ERROR),
            message: translate(STRINGS.SOMETHING_WENT_WRONG),
            actions: [ModalActions.Close()],
          }),
      }
    );
  };

  return {
    withdraw,
  };
}
